import { memo } from "react"

const IconProducts = () => {
  return (
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.5 7H13.5C14.6046 7 15.5 7.89543 15.5 9V13C15.5 14.1046 14.6046 15 13.5 15H9.5C8.39543 15 7.5 14.1046 7.5 13V9C7.5 7.89543 8.39543 7 9.5 7ZM13.5 13.5C13.7761 13.5 14 13.2761 14 13V9C14 8.72386 13.7761 8.5 13.5 8.5H9.5C9.22386 8.5 9 8.72386 9 9V13C9 13.2761 9.22386 13.5 9.5 13.5H13.5Z"
        fill="#6062CB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5 12.25H21.5C21.9142 12.25 22.25 12.5858 22.25 13C22.25 13.4142 21.9142 13.75 21.5 13.75H18.5V14C18.5 16.2091 16.7091 18 14.5 18H14.25V21C14.25 21.4142 13.9142 21.75 13.5 21.75C13.0858 21.75 12.75 21.4142 12.75 21V18H10.25V21C10.25 21.4142 9.91421 21.75 9.5 21.75C9.08579 21.75 8.75 21.4142 8.75 21V18H8.5C6.29086 18 4.5 16.2091 4.5 14V13.75H1.5C1.08579 13.75 0.75 13.4142 0.75 13C0.75 12.5858 1.08579 12.25 1.5 12.25H4.5V9.75H1.5C1.08579 9.75 0.75 9.41421 0.75 9C0.75 8.58579 1.08579 8.25 1.5 8.25H4.5V8C4.5 5.79086 6.29086 4 8.5 4H8.75V1C8.75 0.585786 9.08579 0.25 9.5 0.25C9.91421 0.25 10.25 0.585786 10.25 1V4H12.75V1C12.75 0.585786 13.0858 0.25 13.5 0.25C13.9142 0.25 14.25 0.585786 14.25 1V4H14.5C16.7091 4 18.5 5.79086 18.5 8V8.25H21.5C21.9142 8.25 22.25 8.58579 22.25 9C22.25 9.41421 21.9142 9.75 21.5 9.75H18.5V12.25ZM14.5 16.5C15.8807 16.5 17 15.3807 17 14V8C17 6.61929 15.8807 5.5 14.5 5.5H8.5C7.11929 5.5 6 6.61929 6 8V14C6 15.3807 7.11929 16.5 8.5 16.5H14.5Z"
        fill="#6062CB"
      />
    </svg>
  )
}

export default memo(IconProducts)
